










import Vue from 'vue'
import { get } from 'lodash-es'

import { Stay } from 'models/data/stay'
import stays from '@store/stays'
import TextArea from '@shared/inputs/TextArea.vue'

export default Vue.extend({
    components: {
        TextArea
    },
    props: {
        stay_id: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            summaryPlaceholderText: 'Summary of major symptoms and signs on presentation\nResults of key investigations\nBig picture comment on pre-admission level of function and goals of current care'
        }
    },
    computed: {
        stay(): Stay | undefined {
            return stays.state.stays[this.stay_id]
        },
        summary: {
            get(): string {
                return get(this.stay, 'management_plan.summary') || ''
            },
            set(text: string) {
                stays.extActSetPathValue(this.stay_id, 'management_plan.summary', text)
            }
        }
    }
})
